import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppCustomPreloader } from './strategy';
import { AppLayoutComponent, PublicLayoutComponent } from './Components';
import { AuthGuard } from './guards/auth.guard';
const routes: Routes = [

  {
    path: "",
    redirectTo: "home-page",
    pathMatch: "full",
  },
  {
    path: "admin",
    component: AppLayoutComponent,
    data: { preload: false },
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('../features/admin/admin.module').then((m) => m.AdminModule)
  },
  {
    path: 'home-page',
    component: PublicLayoutComponent,
    data: { preload: false },
    loadChildren: () => import('../features/public/public.module').then((m) => m.PublicModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'reload',
      preloadingStrategy: AppCustomPreloader,
    })
  ],
  exports: [RouterModule],
  providers: [AppCustomPreloader]
})
export class CoreRoutingModule { }
